"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSN = exports.ITIN = exports.EIN = void 0;
exports.EIN = "ein";
exports.ITIN = "itin";
exports.SSN = "ssn";